/**************************************************
 * Nombre:       Tarjeta_Modalidad
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Tarjeta_Modalidad = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
        >

            <Grid container size={{xs: 2, sm: 12, md: 3}} sx={{justifyContent: 'flex-start'}}>
                <img src={item.img} style={{fill: theme.palette.primary.main, width: 48, height: 48}}/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 9, sm: 12, md: 9}}
                sx={{pl: sCell ? 1 : 0}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography
                        sx={{
                            fontSize: 14,
                            lineHeight: 1.2,
                            color: theme.palette.primary.main,
                            textTransform: 'uppercase'
                        }}>{item.nombre}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography
                        sx={{color: theme.palette.primary.main, fontWeight: 600, fontSize: 14, lineHeight: 1.1}}>
                        {item.subtitulo}
                        <span style={{fontWeight: 400, paddingLeft: 4}}>{item.texto}</span>

                    </Typography>
                </Grid>

            </Grid>


        </Grid>
    )

}
export default Tarjeta_Modalidad